<div class="title" mat-dialog-title>
    <span> Are you sure you want to change the size type?</span>
    <p>There are variants created with this size type. If you change the attribute,
        all variant data will be deleted.
    </p>
</div>
<mat-dialog-actions>
    <button mat-button class="cancel" (click)="cancelDeleteVariant()" tabindex="-1">
        Cancel
    </button>
    <button mat-button class="clear" (click)="deleteVariant()" tabindex="-1">
        Yes, change attribute
    </button>
</mat-dialog-actions>
